import axios from '../axios';

function buildQuery (options = {}) {
  const params = {};

  if (options.filters && Object.keys(options.filters).length) {
    for (const filterName in options.filters) {
      params[`filter[${filterName}]`] = options.filters[filterName];
    }
  }

  const query = [];
  for (const param in params) {
    query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
  }

  return query.length ? '?' + query.join('&') : '';
}

export default {
  getServiceAreas (options = {}) {
    return axios.get('/service-area' + buildQuery(options));
  },

  getServiceArea (id) {
    return axios.get(`/service-area/${id}`);
  },

  createServiceArea (params) {
    return axios.post('/service-area', params);
  },

  updateServiceArea (id, data) {
    return axios.put(`/service-area/${id}`, data);
  },

  deleteServiceArea (id) {
    return axios.delete(`/service-area/${id}`);
  },
};
